import { render, staticRenderFns } from "./Comment_Field.vue?vue&type=template&id=183977c4&scoped=true&"
import script from "./Comment_Field.vue?vue&type=script&lang=js&"
export * from "./Comment_Field.vue?vue&type=script&lang=js&"
import style0 from "./Comment_Field.vue?vue&type=style&index=0&id=183977c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183977c4",
  null
  
)

export default component.exports